import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Sidemenu from './Sidemenu'
import Navigation from './Navigation'
import Footer from './Footer'
import ReminderManager from '../view/components/ReminderManager/ReminderManager';
import { listarVouchers } from '../actions/pagosActions';
const Layout = ({children}) => {
  const dispatch = useDispatch();
  const usuario = useSelector((state) => state.usuario?.usuario || state.usuario || null);
  const vouchers = useSelector((state) => state.boletas?.vouchers || []);

  useEffect(()=>{
    if (!("Notification" in window)) {
      console.log("This browser does not support desktop notification");
    } else {
      Notification.requestPermission().then(function(result) {
        //console.log(result);
      });
    }
  },[])
  useEffect(() => {
    if (!usuario) return;

    const rolesActivos = [
      usuario?.nombre_tp_nivel_usuario,
      ...((usuario?.roles || []).map(r => r.nombre_tp_nivel_usuario))
    ].filter(Boolean).map(r => {
      const n = r.trim().toUpperCase();
      return n === "VENTA" ? "VENTAS" : n;
    });

    const idUsuario = usuario?.id_usuario || usuario?.id || 0;

    if (rolesActivos.includes("VENTAS") && idUsuario && vouchers.length === 0) {
      dispatch(listarVouchers(0, 1, idUsuario));
    }
  }, [dispatch, usuario, vouchers.length]);

    return (
      <div className="nav-md">
        <div className="container body">
          <div className="main_container">
            <div
            id="m-nav"
              className="col-md-3 left_col d-none d-md-block"
            >
              <Sidemenu />
            </div>
            <div>
              <Navigation />
            </div>
            <div
              className="right_col"
              role="main"
              style={{ minHeight: "610px" }}
            >
                <ReminderManager />
                {children}
            </div>
            <div>
                <Footer/>
            </div>
          </div>
        </div>
      </div>
    );
}
 
export default Layout;